import { appConfig } from "../config/config";
const { apiBaseUrl, apiVersion } = appConfig;
// const apiBaseUrl = "https://bulk-paycode-portal-api.k8.isw.la/bulk-paycode-portal-api/api/v1"

export const API_URLS = {
    USERS: {
        GET_USERS: `${apiBaseUrl}/admin/cardless-app/users`, //to all users on the app
        GET_USER: `${apiBaseUrl}/admin/users/find`, // to get specific users on the app
        POST_USER_ADMIN: `${apiBaseUrl}/admin`, //to create user
        FIND_USERS: `${apiBaseUrl}/admin/users/find`,
        POST_USER_DOMAIN: `${apiBaseUrl}/users/domain`,
        GET_USER_DOMAIN: `${apiBaseUrl}/app/domains`, //to get all the domains
        GET_USER_ROLE: `${apiBaseUrl}/admin/users/role-mapping`,
        GET_ROLES_ADMIN: `${apiBaseUrl}/admin/app-domain/roles`, //to get all the roles.
        UPDATE_USER_ADMIN: `${apiBaseUrl}/admin`,
        GET_USER_DOMAIN: `${apiBaseUrl}/admin/app/domains`,
        GET_ROLES_DOMAINS: `${apiBaseUrl}/users/domain`,
        ENABLE_USER: `${apiBaseUrl}/admin/users/enable`, //to enable role
        DISABLE_USER: `${apiBaseUrl}/admin/users/disable`, //to disable role
        GET_CURRENT_USER_STATUS: `${apiBaseUrl}/admin/users/status`,
        GET_CURRENT_USER: `/${apiVersion}/user`,
        GET_PERMISSION: `/${apiVersion}/user/permissions`,
    },
    CAMPAIGNS: {
        GET_ALL_CAMPAIGNS: `${apiBaseUrl}/campaign/getAllActiveCampaign`,
        POST_CAMPAIGN: `${apiBaseUrl}/campaign/create`,
        GET_CAMPAIGN: `${apiBaseUrl}/campaign/detail`,
        UPDATE_CAMPAIGN: `${apiBaseUrl}/campaign/update`,
        ENABLE_CAMPAIGN: `${apiBaseUrl}/campaign/enable`,
        DISABLE_CAMPAIGN: `${apiBaseUrl}/campaign/disable`,
        PAUSE_CAMPAIGN: `${apiBaseUrl}/campaign/pause`,
    },
    INSTITUTION: {
        GET_INSTITUTIONS: `${apiBaseUrl}/institutions`,
        FEP: `${apiBaseUrl}/institutions/feps`,
    },
    RANDOMISER: {
        POST_RANDOMISER: `${apiBaseUrl}/raffles`,
    },
    DISBURSEMENT: {
        GET_ALL_DISBURSEMENTS: `${apiBaseUrl}/disbursements`,
        RAFFLES_DROPDOWN: `${apiBaseUrl}/raffles/list?pageNum=&pageSize=&searchKey=`,
        GET_WINNERS_LIST: `${apiBaseUrl}/disbursements/recipients`,
        REVIEW_DISBURSEMENT:`${apiBaseUrl}/disbursements/review`
    },
    VERVEPROMODASHBOARD: {
        VERVE_PROMO_DASHBOARD_DATA: `${apiBaseUrl}/dashboard/vervepromo`,
    },
    DASHBOARD: {
        GET_ALL_DASHBOARD_DATA: `${apiBaseUrl}/dashboard/countAnalysis`,
    },
    ROLES: {
        GET_PERMISSIONS_ROLE: `${apiBaseUrl}/admin/users/app-role-permissions`,
    },
};
